export class Quote {
    public gif: string;
    public backgroundUrl: string;
    public title: string;
    public subtitle: string;

    constructor(gif: string, backgroundUrl: string, title: string, subtitle: string) {
        this.gif = gif;
        this.backgroundUrl = backgroundUrl;
        this.title = title;
        this.subtitle = subtitle;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/qoute.model.ts